import React, { useEffect, useState } from "react";
import { IStaffCommunicationConnect } from "../../../models/dashboard/staffConnect/staffConnect";
import { getStaffDetails } from "../../../action/staff/staffActionCreator";
import { connect, useDispatch } from "react-redux";
import { getDepartments } from "../../../action/common/commonActionCreator";
import FloatingLabelDropDown from "../../../common-components/floatingdropdown";
import { apiConfig } from "../../../constants/apiConfig";
import ReactModal from "react-modal";
import StaffConnectCompose from "./staffConnectCompose";
import { IStaffConnect } from "../../../models/staff/StaffCommunicationDetails";
import { sortAlphabetically } from "../../../common-functions/commonFunctions";
import { suiteType } from "../../../constants/commonConstants";

const StaffConnect = (props: IStaffCommunicationConnect) => {
  const { getAllStaffConnects, staffConnect, getDepartments, departments } =
    props;
  const [showCompose, setShowCompose] = useState(false);
  const [suite] = useState<suiteType>(apiConfig.suite as suiteType);
  const [chat, setChat] = useState<string | undefined>("");
  const [selectedDepartmentId, setSelectedDepartmentId] = useState<
    number | undefined
  >(undefined);
  const [staffToMail, setStaffToMail] = useState<IStaffConnect>();

  useEffect(() => {
    if (suite == suiteType.google) setChat(apiConfig.googleChatUrl);
    else if (suite == suiteType.microsoft) setChat(apiConfig.teamsChatBaseUrl);
  }, []);

  useEffect(() => {
    getAllStaffConnects(selectedDepartmentId);
    getDepartments && getDepartments();
  }, [selectedDepartmentId]);

  const handleOpen = (staffData: IStaffConnect) => {
    setStaffToMail(staffData);
    setShowCompose(true);
  };
  const handleClose = () => setShowCompose(false);

  const onChange = (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const departmentId = Number(event.target.value);
    setSelectedDepartmentId(departmentId);
  };
  return (
    <>
      <div className="card-wrap h-auto stafconn-mobile">
        <div className="title">
          <h2>Staff Directory</h2>
          <div className="col-md-4 form-group">
            <FloatingLabelDropDown
              label={""}
              onChange={onChange}
              isMandatory={false}
              value={selectedDepartmentId}
              name={"departmentId"}
              optionsList={sortAlphabetically(departments)}
              placeholder="-Select Department-"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 mb-3">
            <div className="row">
              {staffConnect != undefined && staffConnect.length > 0 ? (
                staffConnect?.map((communicationData, index) => (
                  <div className="col-grid-5 col-lg-3" key={index}>
                    <div className="card-connect">
                      <div className="img">
                        <img
                          src={communicationData.image}
                          alt=""
                          onError={(e) => {
                            e.currentTarget.src =
                              "/assets/images/icon/DefaultImage.jpeg";
                          }}
                        />
                      </div>
                      <div className="desc">
                        <h2>{communicationData.name}</h2>
                        <h6 className="mb-2">
                          {communicationData.designation}
                        </h6>
                        <a
                          className="comm-emailid"
                          style={{ cursor: "default" }}
                          title={communicationData.emailId}
                        >
                          {communicationData.emailId}
                        </a>
                        <a style={{ cursor: "default" }}>
                          {communicationData.contactNumber}
                        </a>
                      </div>
                      <div className="btns">
                        <a
                          href={chat + communicationData.emailId}
                          target="_blank"
                          className="con-chat"
                          title="Chat"
                        >
                          <img src="/assets/images/icon/chat.svg" alt="" />
                        </a>
                        <a
                          className="con-email"
                          title="Send Email"
                          onClick={() => handleOpen(communicationData)}
                        >
                          <img src="/assets/images/icon/emails.svg" alt="" />
                        </a>
                        <a
                          href="staff-teams.html"
                          className="con-call disabled"
                          target="_blank"
                          title="Call"
                        >
                          <img src="/assets/images/icon/phone.svg" alt="" />
                        </a>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No Records Found</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <ReactModal
        isOpen={showCompose}
        onRequestClose={handleClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
        style={{
          content: {
            outline: "none",
          },
        }}
      >
        <StaffConnectCompose
          setShowStaffConnectCompose={handleClose}
          staffConnect={staffToMail}
        />
      </ReactModal>
    </>
  );
};

const mapDispatchToProps = {
  getAllStaffConnects: (departmentId: number | undefined) =>
    getStaffDetails(departmentId),
  getDepartments: () => getDepartments(),
};

function mapStateToProps(state: any) {
  return {
    staffConnect: state.staffConnect.staffConnectDetails,
    departments: state.common.departments,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StaffConnect);
